{
  "version": 1,
  "asset_id": "a0f745ed-5624-4122-a718-d26b67357cf4",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a0f745ed-5624-4122-a718-d26b67357cf4/sleeve-ugi-reflux-pre-899.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a0f745ed-5624-4122-a718-d26b67357cf4/sleeve-ugi-reflux-pre-899.webp",
  "original_filename": "sleeve-ugi-reflux-pre-899.webp",
  "size": 60990,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:38:31Z"
}
